// extracted by mini-css-extract-plugin
export default {"homeTitle":"c-a_ft","homeTitle_styleDefault":"c-a_fu","homeTitle_styleRed":"c-a_fv"};